import { Card } from '@acceso/design-system';
import clsx from 'clsx';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { useUnderMinDesktopWidth } from '@/hooks/useUnderMinDesktopWidth';

import { SegmentDetailNavigation } from './SegmentDetailNavigation';
import { SegmentsDetailCardBody } from './SegmentsDetailCardBody';
import { SegmentsDetailCardHeader } from './SegmentsDetailCardHeader';

export function SegmentsDetailCard() {
  const { underMinDesktopWith } = useUnderMinDesktopWidth();

  const { visibleBroadcastProgramCards, pinnedId } = useBroadcastScheduleProgram();

  const mainCardsVisible = visibleBroadcastProgramCards.segmentDetail && pinnedId;

  return (
    <Card
      classes={{
        rootSection: clsx(
          '!min-w-full w-full flex-auto order-3 lg:order-2 overflow-auto max-h-[600px] lg:max-h-full',
          {
            '!max-w-[540px] !min-w-0': mainCardsVisible && underMinDesktopWith,
            'max-w-[30%]': mainCardsVisible && !underMinDesktopWith,
          }
        ),
        container: 'py-size-4',
      }}
      id="segments-detail"
    >
      <div className="flex flex-col gap-2">
        <SegmentsDetailCardHeader />
        <SegmentsDetailCardBody />
        <SegmentDetailNavigation />
      </div>
    </Card>
  );
}
